export enum ResponsiveTarget {
  XS,
  SM,
  MD,
  LG,
  XL,
}
